/**
 * Handle all the logic necessary to open new module windows.
 */
import AppModule from "common/enums/AppModule";
import topic from "common/managers/topic";
import window from "common/objects/window";

export default {

    _getHashToLoad: function(module, hash) {
        if (hash) {
            return hash;
        } else {
            var details = AppModule.getDetails(module);
            if (details && details.hash) {
                return "#" + details.hash;
            }
        }
        return null;
    },

    _getLocationToLoad: function(module) {
        var details = AppModule.getDetails(module);
        if (details) {
            if (details.url) {
                return context.path + "/app/" + details.url + "/";
            } else {
                return context.path + "/app/index.html";
            }
        }
        return null;
    },

    /**
     * Open a module with an optional hash.
     * @param module module name
     * @param hash Data after the # to pass. If passed, it must include the module name
     * @returns {*}
     */
    openModule: function(module, hash) {
        // All HTML modules should open in a new tab.
        const details = AppModule.getDetails(module);
        const targetHash = this._getHashToLoad(module, hash);
        const targetLocation = this._getLocationToLoad(module);
        const targetUrl = targetLocation + (targetHash ? targetHash : "");
        if (details) {

            const opened = window.open(targetUrl);

            if (!opened) {
                //popup blocker
                topic.publish("app/module/failed");
            }

            return opened;
        } else {
            throw new Error("A valid module must be passed.");
        }
    }
};
